export const API_URL = 'https://randomuser.me/api/?inc=name&results=10';
